import { defineStyleConfig } from '@chakra-ui/styled-system';

const ProgressBarTheme = defineStyleConfig({
  baseStyle: {
    filledTrack: {
      backgroundColor: 'purple.90',
      height: '100%',
      transition: '400ms',
    },
    track: {
      backgroundColor: 'transparent',
      height: '4',
    },
  },
});

export default ProgressBarTheme;
